<div [ngClass]="cardClasses()" [attr.data-state]="data()?.state">
  <v-one-card-header
    [title]="stateConfig().label"
    [consecutives]="data()?.codes || []"
    [cardState]="data()?.state || 'order'"
    [icon]="stateConfig().icon"
    [iconColor]="stateConfig().color"
    [indicatorColor]="stateConfig().color"
    [showMenu]="config().showActions ?? true"
    [menuOptions]="config().menuOptions || []"
    [hasCreditNote]="data()?.hasCreditNote || false"
    [hasDebitNote]="data()?.hasDebitNote || false"
    (menuAction)="handleMenuAction($event)"
  >
  </v-one-card-header>

  <v-one-card-body
    [cardCodes]="data()?.codes || []"
    [cardClient]="data()?.client || ''"
    [cardClientLabel]="data()?.clientLabelKey"
    [cardAddress]="data()?.address || ''"
    [cardCreationDate]="data()?.creationDate"
    [cardDueDate]="data()?.dueDate"
    [cardTotal]="data()?.total"
    [cardOriginalTotal]="data()?.originalTotal"
    [cardCurrency]="data()?.currency"
    [cardState]="data()?.state || 'order'"
    [cardPendingAmount]="data()?.pendingAmount"
    [idInvoice]="data()?.idInvoice"
    (notesDetailClick)="handleNotesDetailClick($event)"
  >
  </v-one-card-body>

  @if (config().showFooter !== false) {
    <v-one-card-footer
      [showDropdown]="config().showActions ?? true"
      [dropdownItems]="config().dropdownItems || []"
      [notes]="data()?.notes"
      [cardState]="data()?.state || 'order'"
      [idInvoice]="data()?.idInvoice"
      [ctaLabel]="config().ctaLabel"
      [ctaAction]="config().ctaAction"
      [currency]="data()?.currency || 'USD'"
      [hasAdvance]="data()?.hasAdvance || false"
      [advanceAmount]="data()?.advanceAmount"
      [hasFavorBalance]="data()?.hasFavorBalance || false"
      [favorBalanceAmount]="data()?.favorBalanceAmount"
      (dropdownAction)="handleDropdownAction($event)"
    >
    </v-one-card-footer>
  }
</div>
